function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.731 3.32H.929v4.715h7.802V10.5l6.341-4.929L8.731.642v2.679" fillRule="evenodd" /></svg>;
});